import { OrderDirection } from 'store/spot/types'
import { Ether, Price, SymbolId, SymbolName, Timestamp } from 'types'

export interface Tick {
  key: string // created by uuid v4, used for react key
  symbol: string
  timestamp: Timestamp
  direction: OrderDirection
  price: number
  quantity: number // SPOTS: size, CONTRACTS: quantity, 1.000000
  volume: number
  flag: 0 | 1 // 0: normal, Waiting the server to add liquidation and ADL and more flags
}

export interface OrderbookData {
  symbolId: SymbolId
  symbol: SymbolName
  price: Price
  sellOrders: OrderbookDataItem[]
  buyOrders: OrderbookDataItem[]
  sequenceId: number
  lastSequenceId?: number // Existed in incrementalOrderbookAction
  direction: OrderDirection
}
export interface OrderbookDataItem {
  price: Ether
  amount: Ether
  animationFlag?: boolean
  percent?: number
}
export enum ShowListType {
  all,
  sell,
  buy,
}
